module.exports = __webpack_public_path__ + "static/media/express_color.dcdff3f4.png";